import React, { useEffect, useMemo, useRef, useState } from "react";
import { AnimatePresence } from "framer-motion";
import Script from "next/script";

import MainTemplate from "@/components/Templates/MainTemplate";
import HeroSection from "./HeroSection";
import DynamicContent from "./DynamicContent";
import SimilarRecipeList from "./SimilarRecipe";
// import DownloadAppModal from "./DownloadAppModal";
import dynamic from "next/dynamic";

const DownloadAppModal = dynamic(() => import("./DownloadAppModal"), {
  ssr: false,
});

import { useWindowDimensions } from "@/hooks";
import useDisableIntercom from "@/hooks/useDisableIntercom";

import { useAppSelector } from "@/hooks";

import { mapRecipeData } from "./mapRecipeData";
import {
  generateBreadcrumbSchemaData,
  generateCarouselSchemaData,
  generateRecipeSchemeData,
} from "./generateSchema";

function RecipePage() {
  const { width: innerWidth } = useWindowDimensions();

  const [width, setWidth] = useState(400);

  useEffect(() => {
    setWidth(innerWidth);
  }, [innerWidth]);

  const heroBannerRef = useRef(null);
  const footerRef = useRef(null);

  const [showModal, setShowModal] = useState(false);

  const { success, error, data } = useAppSelector((state) => state.recipe);

  useDisableIntercom({});


  const {
    hero,
    similarRecipes,
    modalData,
    downloadBanner,
    attributeData,
    ingredientsData,
    methodData,
    breadcrumbData,
    collectionData,
  } = useMemo(() => mapRecipeData(data), [data]);

  const recipeSchemaData = generateRecipeSchemeData({
    hero,
    ingredientsData,
    methodData,
    similarRecipes,
    collectionData,
    attributeData,
    breadcrumbData,
  });

  const carouselData = generateCarouselSchemaData({
    similarRecipes,
  });

  const breadcrumbSchemaData = generateBreadcrumbSchemaData({ breadcrumbData });

  const Hero = (
    <HeroSection
      data={hero}
      downloadBanner={downloadBanner}
      width={width}
      heroBannerRef={heroBannerRef}
    />
  );

  const Content: any = (
    <DynamicContent
      width={width}
      data={data}
      heroContentData={hero}
      attributeData={attributeData}
      ingredientsData={ingredientsData}
      methodData={methodData}
    />
  );

  const SimilarRecipes = similarRecipes?.similarList.length > 0 && (
    <SimilarRecipeList data={similarRecipes} setShowModal={setShowModal} />
  );


  const Modal = (
    <AnimatePresence>
      {showModal && (
        <DownloadAppModal
          width={width}
          setShowModal={setShowModal}
          data={modalData}
        />
      )}
    </AnimatePresence>
  );

  return (
    <MainTemplate error={error} footerRef={footerRef}>
      {Hero}
      {Content}
      {SimilarRecipes}
      <Script
        id="recipeSchemaData"
        defer
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(recipeSchemaData) }}
      />
      {/* <Script
          id={carouselData}
          defer
          type="application/ld+json"
          dangerouslySetInnerHTML={{ __html: JSON.stringify(carouselData) }}
        /> */}
      <Script
        id="breadcrumbSchemaData"
        defer
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify(breadcrumbSchemaData),
        }}
      />
    </MainTemplate>
  );
}

export default RecipePage;
